import {
  ACTIVE_CUSTOMER_DISPLAY,
  ENABLE_CUSTOMER_DISPLAY,
  LOGOUT_USER,
} from 'redux/types'

const initState = {
  isActiveCustomerDisplay: false,
  isCustomerDisplayEnabled: null,
}

export default function customerDisplayReducer(state = initState, action) {
  switch (action.type) {
    case ACTIVE_CUSTOMER_DISPLAY:
      return {
        ...state,
        isActiveCustomerDisplay: action.payload,
      }

    case ENABLE_CUSTOMER_DISPLAY:
      return {
        ...state,
        isCustomerDisplayEnabled: action.payload,
      }

    case LOGOUT_USER:
      return { ...initState }

    default:
      return state
  }
}
